export default __webpack_public_path__ + "static/media/datalab-logo.24bc3aed.svg";